<template>
    <div class="animated fadeIn is-background-dark1">
        <section class="section">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content is-mobile">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center text-white">
                            {{ $t('poc:poc.feedback_title') }}
                        </h3>
                    </div>
                </div>
                <div class="columns is-centered">
                    <div class="column content" style="flex: inherit">
                        <figure class="image featured-in-img" v-if="!isMobile()">
                            <img alt="World coverage PTT" src="./assets/unlimited-new.svg" width="600" height="600">
                        </figure>
                        <figure class="image featured-in-img-mobile mobile-screen" v-else>
                            <img alt="World coverage PTT" src="./assets/unlimited-new.svg" width="300" height="300">
                        </figure>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container">
                        <p class="is-size- small-container uptin-text-center uptin-text-7 text-white">
                            {{ $t('poc:poc.feedback_description') }}
                        </p>
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>

<style lang="scss">
</style>

<script>
export default {
    components: {
    },
    name: 'unlimited',
    methods: {
        isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        }
    }
}
</script>
